import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class AzureTelemetryNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Azure Telemetry';
        this.id = 'node_azure_telemetry';
        this.linkedFeature = 'azure';

        this.inputs = [
            {
                name: 'Send',
                portId: 'azure_pub',
                params: [],
            },
        ];
        const settings: Setting[] = [
            {
                id: 'TELEMETRY_ID',
                name: 'Telemetry ID',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'TELEMETRY_VALUE',
                name: 'Telemetry Value',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'azure_pub');
        const TELEMETRY_ID = this.getSettingValue('TELEMETRY_ID');
        const TELEMETRY_VALUE = this.getSettingValue('TELEMETRY_VALUE');


        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
            const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    azure_store_telemetry(${project.parseCodeExpression(TELEMETRY_ID, sourceParams, TibboDataType.STRING)}, ${project.parseCodeExpression(TELEMETRY_VALUE, sourceParams, TibboDataType.STRING)})
                `,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev_demo_03';
    }
}
